/** Coordenadas GPS devueltas al componente cuando el navegador resuelve la posición. */
export interface IGeolocationCoordinates {
	latitude: number;
	longitude: number;
}

/** Timeout (ms) de `getCurrentPosition` mientras el usuario responde al prompt nativo. */
export const GEOLOCATION_TIMEOUT_MS = 10000;

/** `GeolocationPositionError.code`: permiso denegado; el servicio puede reintentar si el usuario concede después. */
export const GEOLOCATION_ERROR_PERMISSION_DENIED = 1;

/** `GeolocationPositionError.code`: expiró la espera del prompt; el servicio escucha grant tardío. */
export const GEOLOCATION_ERROR_TIMEOUT = 3;
